var _classCallCheck = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var qs = require('querystringify');

var unique = require('array-unique');

var chunk = require('chunk');

var hashString = require('./hash');

var clone = function clone(x) {
  return JSON.parse(JSON.stringify(x));
};

module.exports =
/*#__PURE__*/
function () {
  "use strict";

  function AbstractEndpoint(parent) {
    _classCallCheck(this, AbstractEndpoint);

    this.client = parent.client;
    this.lang = parent.lang;
    this.apiKey = parent.apiKey;
    this.fetch = parent.fetch;
    this.caches = parent.caches;
    this.debug = parent.debug;
    this.baseUrl = 'https://api.guildwars2.com';
    this.isPaginated = false;
    this.maxPageSize = 200;
    this.isBulk = false;
    this.supportsBulkAll = true;
    this.isLocalized = false;
    this.isAuthenticated = false;
    this.isOptionallyAuthenticated = false;
    this.credentials = false;
    this._skipCache = false;
  } // Set the language for locale-aware endpoints


  _createClass(AbstractEndpoint, [{
    key: "language",
    value: function language(lang) {
      this.lang = lang;
      this.debugMessage("set the language to ".concat(lang));
      return this;
    } // Set the api key for authenticated endpoints

  }, {
    key: "authenticate",
    value: function authenticate(apiKey) {
      this.apiKey = apiKey;
      this.debugMessage("set the api key to ".concat(apiKey));
      return this;
    } // Set the debugging flag

  }, {
    key: "debugging",
    value: function debugging(flag) {
      this.debug = flag;
      return this;
    } // Print out a debug message if debugging is enabled

  }, {
    key: "debugMessage",
    value: function debugMessage(string) {
      if (this.debug) {
        console.log("[gw2api-client] ".concat(string));
      }
    } // Skip caching and get the live data

  }, {
    key: "live",
    value: function live() {
      this._skipCache = true;
      this.debugMessage("skipping cache");
      return this;
    } // Get all ids

  }, {
    key: "ids",
    value: function ids() {
      var _this = this;

      this.debugMessage("ids(".concat(this.url, ") called"));

      if (!this.isBulk) {
        return Promise.reject(new Error('"ids" is only available for bulk expanding endpoints'));
      } // There is no cache time set, so always use the live data


      if (!this.cacheTime) {
        return this._ids();
      } // Get as much as possible out of the cache


      var hash = this._cacheHash('ids');

      var handleCacheContent = function handleCacheContent(cached) {
        if (cached) {
          _this.debugMessage("ids(".concat(_this.url, ") resolving from cache"));

          return cached;
        }

        return _this._ids().then(function (content) {
          _this._cacheSetSingle(hash, content);

          return content;
        });
      }; // Get the content either from the cache or API, write it into the cache and return a clone


      var contentPromise = this._skipCache ? Promise.resolve(false).then(handleCacheContent) : this._cacheGetSingle(hash).then(handleCacheContent);
      return contentPromise.then(clone);
    } // Get all ids from the live API

  }, {
    key: "_ids",
    value: function _ids() {
      this.debugMessage("ids(".concat(this.url, ") requesting from api"));
      return this._request(this.url);
    } // Get a single entry by id

  }, {
    key: "get",
    value: function get(id) {
      var _this2 = this;

      var url = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      this.debugMessage("get(".concat(this.url, ") called"));

      if (!id && this.isBulk && !url) {
        return Promise.reject(new Error('"get" requires an id'));
      } // There is no cache time set, so always use the live data


      if (!this.cacheTime) {
        return this._get(id, url);
      } // Get as much as possible out of the cache


      var hash = this._cacheHash(id);

      var handleCacheContent = function handleCacheContent(cached) {
        if (cached) {
          _this2.debugMessage("get(".concat(_this2.url, ") resolving from cache"));

          return cached;
        }

        return _this2._get(id, url).then(function (content) {
          _this2._cacheSetSingle(hash, content);

          return content;
        });
      }; // Get the content either from the cache or API, write it into the cache and return a clone


      var contentPromise = this._skipCache ? Promise.resolve(false).then(handleCacheContent) : this._cacheGetSingle(hash).then(handleCacheContent);
      return contentPromise.then(clone);
    } // Get a single entry by id from the live API

  }, {
    key: "_get",
    value: function _get(id, url) {
      this.debugMessage("get(".concat(this.url, ") requesting from api")); // Request the single id if the endpoint a bulk endpoint

      if (this.isBulk && !url) {
        return this._request("".concat(this.url, "?id=").concat(id));
      } // We are dealing with a custom url instead


      if (url) {
        return this._request(this.url + id);
      } // Just request the base url


      return this._request(this.url);
    } // Get multiple entries by ids

  }, {
    key: "many",
    value: function many(ids) {
      var _this3 = this;

      this.debugMessage("many(".concat(this.url, ") called (").concat(ids.length, " ids)"));

      if (!this.isBulk) {
        return Promise.reject(new Error('"many" is only available for bulk expanding endpoints'));
      } // Exit out early if we don't request any ids


      if (ids.length === 0) {
        return Promise.resolve([]);
      } // Always only work on unique ids, since that's how the API works


      ids = unique.immutable(ids); // There is no cache time set, so always use the live data

      if (!this.cacheTime) {
        return this._many(ids);
      } // Get as much as possible out of the cache


      var hashes = ids.map(function (id) {
        return _this3._cacheHash(id);
      });

      var handleCacheContent = function handleCacheContent(cached) {
        cached = cached.filter(function (x) {
          return x;
        });

        if (cached.length === ids.length) {
          _this3.debugMessage("many(".concat(_this3.url, ") resolving fully from cache"));

          return cached;
        }

        _this3.debugMessage("many(".concat(_this3.url, ") resolving partially from cache (").concat(cached.length, " ids)"));

        var missingIds = getMissingIds(ids, cached);
        return _this3._many(missingIds, cached.length > 0).then(function (content) {
          var cacheContent = content.map(function (value) {
            return [_this3._cacheHash(value.id), value];
          });

          _this3._cacheSetMany(cacheContent); // Merge the new content with the cached content and guarantee element order


          content = content.concat(cached);
          return _this3._sortByIdList(content, ids);
        });
      }; // Find the ids that are missing in the cached data


      var getMissingIds = function getMissingIds(ids, cached) {
        var cachedIds = {};
        cached.map(function (x) {
          cachedIds[x.id] = 1;
        });
        return ids.filter(function (x) {
          return cachedIds[x] !== 1;
        });
      }; // Get the content either from the cache or API, write it into the cache and return a clone


      var contentPromise = this._skipCache ? Promise.resolve([]).then(handleCacheContent) : this._cacheGetMany(hashes).then(handleCacheContent);
      return contentPromise.then(clone);
    } // Get multiple entries by ids from the live API

  }, {
    key: "_many",
    value: function _many(ids) {
      var _this4 = this;

      var partialRequest = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      this.debugMessage("many(".concat(this.url, ") requesting from api (").concat(ids.length, " ids)")); // Chunk the requests to the max page size

      var pages = chunk(ids, this.maxPageSize);
      var requests = pages.map(function (page) {
        return "".concat(_this4.url, "?ids=").concat(page.join(','));
      }); // If we are partially caching and all not-cached ids are all invalid,
      // simulate the API behaviour by silently swallowing errors.

      var handleMissingIds = function handleMissingIds(err) {
        /* istanbul ignore else */
        if (partialRequest && err.response && err.response.status === 404) {
          return Promise.resolve([]);
        }
        /* istanbul ignore next */


        return Promise.reject(err);
      }; // Work on all requests in parallel and then flatten the responses into one


      return this._requestMany(requests).then(function (responses) {
        return responses.reduce(function (x, y) {
          return x.concat(y);
        }, []);
      }).catch(handleMissingIds);
    } // Get a single page

  }, {
    key: "page",
    value: function page(_page) {
      var _this5 = this;

      var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.maxPageSize;
      this.debugMessage("page(".concat(this.url, ") called"));

      if (!this.isBulk && !this.isPaginated) {
        return Promise.reject(new Error('"page" is only available for bulk expanding or paginated endpoints'));
      }

      if (size > this.maxPageSize || size <= 0) {
        return Promise.reject(new Error("\"size\" has to be between 0 and ".concat(this.maxPageSize, ", was ").concat(size)));
      }

      if (_page < 0) {
        return Promise.reject(new Error('page has to be 0 or greater'));
      } // There is no cache time set, so always use the live data


      if (!this.cacheTime) {
        return this._page(_page, size);
      } // Get as much as possible out of the cache


      var hash = this._cacheHash('page-' + _page + '/' + size);

      var handleCacheContent = function handleCacheContent(cached) {
        if (cached) {
          _this5.debugMessage("page(".concat(_this5.url, ") resolving from cache"));

          return cached;
        }

        return _this5._page(_page, size).then(function (content) {
          var cacheContent = [[hash, content]];

          if (_this5.isBulk) {
            cacheContent = cacheContent.concat(content.map(function (value) {
              return [_this5._cacheHash(value.id), value];
            }));
          }

          _this5._cacheSetMany(cacheContent);

          return content;
        });
      }; // Get the content either from the cache or API, write it into the cache and return a clone


      var contentPromise = this._skipCache ? Promise.resolve(false).then(handleCacheContent) : this._cacheGetSingle(hash).then(handleCacheContent);
      return contentPromise.then(clone);
    } // Get a single page from the live API

  }, {
    key: "_page",
    value: function _page(page, size) {
      this.debugMessage("page(".concat(this.url, ") requesting from api"));
      return this._request("".concat(this.url, "?page=").concat(page, "&page_size=").concat(size));
    } // Get all entries

  }, {
    key: "all",
    value: function all() {
      var _this6 = this;

      this.debugMessage("all(".concat(this.url, ") called"));

      if (!this.isBulk && !this.isPaginated) {
        return Promise.reject(new Error('"all" is only available for bulk expanding or paginated endpoints'));
      } // There is no cache time set, so always use the live data


      if (!this.cacheTime) {
        return this._all();
      } // Get as much as possible out of the cache


      var hash = this._cacheHash('all');

      var handleCacheContent = function handleCacheContent(cached) {
        if (cached) {
          _this6.debugMessage("all(".concat(_this6.url, ") resolving from cache"));

          return cached;
        }

        return _this6._all().then(function (content) {
          var cacheContent = [[hash, content]];

          if (_this6.isBulk) {
            cacheContent = cacheContent.concat(content.map(function (value) {
              return [_this6._cacheHash(value.id), value];
            }));
          }

          _this6._cacheSetMany(cacheContent);

          return content;
        });
      }; // Get the content either from the cache or API, write it into the cache and return a clone


      var contentPromise = this._skipCache ? Promise.resolve(false).then(handleCacheContent) : this._cacheGetSingle(hash).then(handleCacheContent);
      return contentPromise.then(clone);
    } // Get all entries from the live API

  }, {
    key: "_all",
    value: function _all() {
      var _this7 = this;

      this.debugMessage("all(".concat(this.url, ") requesting from api")); // Use bulk expansion if the endpoint supports the "all" keyword

      if (this.isBulk && this.supportsBulkAll) {
        return this._request("".concat(this.url, "?ids=all"));
      } // Get everything via all pages instead


      var totalEntries;
      return this._request("".concat(this.url, "?page=0&page_size=").concat(this.maxPageSize), 'response').then(function (firstPage) {
        // Get the total number of entries off the first page's headers
        totalEntries = firstPage.headers.get('X-Result-Total');
        return firstPage.json();
      }).then(function (result) {
        // Return early if the first page already includes all entries
        if (totalEntries <= _this7.maxPageSize) {
          return result;
        } // Request all missing pages in parallel


        var requests = [];

        for (var page = 1; page < Math.ceil(totalEntries / _this7.maxPageSize); page++) {
          requests.push("".concat(_this7.url, "?page=").concat(page, "&page_size=").concat(_this7.maxPageSize));
        }

        return _this7._requestMany(requests).then(function (responses) {
          responses = responses.reduce(function (x, y) {
            return x.concat(y);
          }, []);
          return result.concat(responses);
        });
      });
    } // Set a single cache key in all connected cache storages

  }, {
    key: "_cacheSetSingle",
    value: function _cacheSetSingle(key, value) {
      var _this8 = this;

      this.caches.map(function (cache) {
        return cache.set(key, value, _this8.cacheTime);
      });
    } // Set multiples cache key in all connected cache storages

  }, {
    key: "_cacheSetMany",
    value: function _cacheSetMany(values) {
      var _this9 = this;

      values = values.map(function (value) {
        return [value[0], value[1], _this9.cacheTime];
      });
      this.caches.map(function (cache) {
        return cache.mset(values);
      });
    } // Get a cached value out of the first possible connected cache storages

  }, {
    key: "_cacheGetSingle",
    value: function _cacheGetSingle(key) {
      var _this10 = this;

      var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      return this.caches[index].get(key).then(function (value) {
        if (value || index === _this10.caches.length - 1) {
          return value;
        }

        return _this10._cacheGetSingle(key, ++index);
      });
    } // Get multiple cached values out of the first possible connected cache storages

  }, {
    key: "_cacheGetMany",
    value: function _cacheGetMany(keys) {
      var _this11 = this;

      var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      return this.caches[index].mget(keys).then(function (values) {
        var cleanValues = values.filter(function (x) {
          return x;
        }); // We got all the requested keys or are through all storages

        if (cleanValues.length === keys.length || index === _this11.caches.length - 1) {
          return values;
        } // Try to ask the next storage for the keys that we didn't get


        var missingKeys = values.map(function (value, i) {
          return value ? false : keys[i];
        }).filter(function (value) {
          return value;
        }); // Then merge the values of the next storage into the missing slots

        return _this11._cacheGetMany(missingKeys, ++index).then(function (missingValues) {
          var i = 0;
          return values.map(function (value) {
            return value || missingValues[i++];
          });
        });
      });
    } // Get a cache hash for an identifier

  }, {
    key: "_cacheHash",
    value: function _cacheHash(id) {
      var hash = hashString(this.baseUrl + this.url);

      if (id) {
        hash += ':' + id;
      }

      if (this.isLocalized) {
        hash += ':' + this.lang;
      }

      if (this._usesApiKey()) {
        hash += ':' + hashString(this.apiKey + '');
      }

      return hash;
    } // Execute a single request

  }, {
    key: "_request",
    value: function _request(url) {
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'json';
      url = this._buildUrl(url);
      /* istanbul ignore next */

      var credentials = this.credentials ? 'include' : undefined;
      return this.fetch.single(url, {
        type: type,
        credentials: credentials
      });
    } // Execute multiple requests in parallel

  }, {
    key: "_requestMany",
    value: function _requestMany(urls) {
      var _this12 = this;

      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'json';
      urls = urls.map(function (url) {
        return _this12._buildUrl(url);
      });
      /* istanbul ignore next */

      var credentials = this.credentials ? 'include' : undefined;
      return this.fetch.many(urls, {
        type: type,
        credentials: credentials
      });
    } // Build the headers for localization and authentication

  }, {
    key: "_buildUrl",
    value: function _buildUrl(url) {
      // Add the base url
      url = this.baseUrl + url; // Parse a possibly existing query

      var parsedUrl = url.split('?');
      var query = qs.parse(parsedUrl[1] || ''); // Only set the API key for authenticated endpoints,
      // when it is required or optional and set on the client

      if (this._usesApiKey()) {
        query['access_token'] = this.apiKey;
      } // Set the language for localized endpoints


      if (this.isLocalized) {
        query['lang'] = this.lang;
      } // Build the url with the finished query


      query = qs.stringify(query, true).replace(/%2C/g, ',');
      return parsedUrl[0] + query;
    } // Guarantee the element order of bulk results

  }, {
    key: "_sortByIdList",
    value: function _sortByIdList(entries, ids) {
      // Hash map of the indexes for better time complexity on big arrays
      var indexMap = {};
      ids.map(function (x, i) {
        indexMap[x] = i;
      }); // Sort by the indexes

      entries.sort(function (a, b) {
        return indexMap[a.id] - indexMap[b.id];
      });
      return entries;
    }
  }, {
    key: "_usesApiKey",
    value: function _usesApiKey() {
      return this.isAuthenticated && (!this.isOptionallyAuthenticated || this.apiKey);
    }
  }]);

  return AbstractEndpoint;
}();